<template>
    <el-row class="container">
      <el-col :md="24" class="header">
        <div class="text-center">
          <h1>404</h1>
          <h2 class="my-3 headline">Sorry, the page you are looking for could not be found.</h2>
          <div>
            <el-button type="primary" @click="goHome">Go Home</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push({ name: 'dashboard' });
    },
  },
};
</script>
<style scoped lang="css">
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
